import Link from "next/link";
import { MapPin, Utensils } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { useTranslation } from "@/hooks/useTranslation";

export default function CallToAction() {
  const { language } = useLanguage();
  const { t } = useTranslation();

  return (
    <section className="text-center mt-24 py-16 px-4 bg-gray-50 rounded-2xl">
      <h2 className="text-[22px] md:text-3xl font-bold text-gray-900 mb-4">
        {t('cta_title')}
      </h2>
      <p className="text-base md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
        {t('cta_subtitle')}
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link 
          href={`/${language}/places/restaurants`}
          className="inline-flex items-center justify-center px-6 py-3 bg-gray-900 text-white font-medium rounded-lg hover:bg-gray-800 transition-colors"
        >
          <Utensils className="mr-2 w-5 h-5" />
          {t('find_restaurants')}
        </Link>
        <Link 
          href={`/${language}/places/attractions`}
          className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
        >
          <MapPin className="mr-2 w-5 h-5" />
          {t('explore_attractions')}
        </Link>
      </div>
    </section>
  );
} 